module.exports = __webpack_public_path__ + "img/sent.d526bdd8.png";